exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-network {\n  width: 100%;\n  min-height: 600px;\n  height: calc(100vh - 260px);\n  border: 1px solid lightgray;\n}\n\n.button-row {\n  margin-top: 20px;\n}\n\n.caption {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.question-network-area {\n  position: relative;\n}\n\n.hover-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 2px 5px;\n  background-color: white;\n  border: 1px solid lightgray;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/tree-view.component.css
// module id = ../../../../../src/app/modules/dynamic-tips/tree-view/tree-view.component.css
// module chunks = main